module.exports = __webpack_public_path__ + "static/thank-you-page-characters.1a7ba8eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/thank-you-page-characters.png
// module id = 1516
// module chunks = 168707334958949